/*
export default Object.freeze({
    DOMAIN: "http://127.0.0.1:5000"
});
export default Object.freeze({
    DOMAIN: "http://***.***.***.***"
});
*/
export default Object.freeze({
    DOMAIN: "/",
    PREFIX: "wtinfo"
    //PREFIX: ""
});
